/** @format */

import {OptionDescription} from 'frontier/ds/quoter/laminate_material_select_descriptions';
import {Tabs, Tab, GridSelect} from '@sttark/design-system';
import React, {useState, memo, useEffect} from 'react';
import PropTypes from 'prop-types';

import {
    SUBSTRATE_AVON_CLASSIC_CREST,
    SUBSTRATE_BLACK_VELLUM,
    SUBSTRATE_CLEAR_PLASTIC,
    SUBSTRATE_ESTATE4_PAPER,
    SUBSTRATE_KRAFT_PAPER,
    SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
    SUBSTRATE_SILVER_METALLIC_PLASTIC,
    SUBSTRATE_TERRA_SKIN,
    SUBSTRATE_ULTRA_CLEAR_PLASTIC,
    SUBSTRATE_WHITE_PLASTIC,
    SUBSTRATE_WHITE_VINYL,
    SUBSTRATE_WHITE_PAPER,
    SUBSTRATES
} from 'frontier-constants';

function MaterialSelect({value, ...props}) {
    const [activeTab, setActiveTab] = useState('all');
    const [substrates, setSubstrates] = useState([]);

    const onTabChange = v => {
        setActiveTab(v);
        props.onTabChange?.(v);
    };

    useEffect(() => {
        const substrateToGridSelectOption = substrate => ({
            value: substrate.id,
            label: substrate.label,
            image: substrate.image,
            hoverImage: substrate.hoverImage,
            description: <OptionDescription option={substrate} className="label-select" />
        });

        let substrates = [];
        if (activeTab === 'all') substrates = SUBSTRATES.map(substrateToGridSelectOption);
        else {
            const materialIds = materials[activeTab] || [];
            substrates = materialIds
                .map(mid => SUBSTRATES.find(({id}) => mid === id))
                .map(substrateToGridSelectOption);
        }

        setSubstrates(substrates);
    }, [activeTab]);

    return (
        <>
            <div className="d-flex justify-content-start align-items-start">
                <div className="d-flex justify-content-start align-items-center mt-4 me-4 flex-shrink-0">
                    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" className="me-1">
                        <path
                            d="M24.5032 0.8125H1.497C0.731374 0.8125 0.25325 1.64688 0.637625 2.3125L7.90637 14.6688V22.1875C7.90637 22.7406 8.35012 23.1875 8.90012 23.1875H17.1001C17.6501 23.1875 18.0939 22.7406 18.0939 22.1875V14.6688L25.3657 2.3125C25.747 1.64688 25.2689 0.8125 24.5032 0.8125ZM15.8564 20.9375H10.1439V16.0625H15.8595V20.9375H15.8564ZM16.1564 13.5438L15.8595 14.0625H10.1407L9.84387 13.5438L3.647 3.0625H22.3532L16.1564 13.5438Z"
                            fill="#26313A"
                        />
                    </svg>
                    <p className="my-0 ml-0 mr-2 p-0">Sort By:</p>
                </div>
                <Tabs activeTab={activeTab} onChange={onTabChange}>
                    <Tab name="all" title="All Materials" />
                    <Tab name="best_sellers" title="Best Sellers" />
                    <Tab name="waterproof" title="Waterproof" />
                    <Tab name="eco_friendly" title="Eco-Friendly" />
                    <Tab name="unlaminated" title="Unlaminated" />
                </Tabs>
            </div>
            <GridSelect
                onChange={props.onChange}
                options={substrates}
                value={value}
                minCols={3}
                maxCols={3}
                ratio="1x1"
            />
        </>
    );
}

export default memo(MaterialSelect);

MaterialSelect.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func
};

const materials = {
    best_sellers: [
        SUBSTRATE_WHITE_PLASTIC,
        SUBSTRATE_SILVER_METALLIC_PLASTIC,
        SUBSTRATE_WHITE_PAPER,
        SUBSTRATE_WHITE_VINYL,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC
    ],
    waterproof: [
        SUBSTRATE_WHITE_PLASTIC,
        SUBSTRATE_SILVER_METALLIC_PLASTIC,
        SUBSTRATE_ULTRA_CLEAR_PLASTIC,
        SUBSTRATE_CLEAR_PLASTIC,
        SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
        SUBSTRATE_WHITE_VINYL
    ],
    eco_friendly: [SUBSTRATE_AVON_CLASSIC_CREST, SUBSTRATE_TERRA_SKIN, SUBSTRATE_KRAFT_PAPER],
    unlaminated: [
        SUBSTRATE_ESTATE4_PAPER,
        SUBSTRATE_AVON_CLASSIC_CREST,
        SUBSTRATE_KRAFT_PAPER,
        SUBSTRATE_BLACK_VELLUM
    ]
};
